/**
 * Add ?lo=PBJB as a URL parameter to all AMNH links
 */

jQuery(function($){

  const query = {
    key: 'lo',
    value: 'PBJB'
  };
  const regex = /^https:\/\/(?:[a-zA-Z0-9-]+\.)?amnhealthcare\.com(?:\/(?!careers\/.*\/apply).*)?$/;

  (function init(){

    // Use mousedown/touchstart to fire the event on rightclick, left click and touch
    $(document).on('mousedown touchstart', 'a', setLinkQueryString);

    // [card_viewer]
    $(document).on('vclick ', '.card.card--active', handleCardClick);
    $(document).on('vclick ', '.card__details', (event) => event.preventDefault());
  })();


  /**
   * Get tracking URL if input matches
   * @param {*} input 
   * @returns 
   */
  function getTrackingUrl(input){
    let url;

    if(!regex.test(input)) {
      return input;
    }
    
    url = new URL(input)
    url.searchParams.set(query.key, query.value);
    return url.toString();
  }


  /**
   * Append query arguments to outbound links
   */
  function setLinkQueryString() {
    const href = $(this).attr('href');
    $(this).attr('href', getTrackingUrl(href));
  }


  /**
   * Open card link with tracking code in a new window
   */
  function handleCardClick(event) {
    const url = $(this).find('.card__details').attr('href');
    window.open(getTrackingUrl(url), "_blank");
  }
});
